import React, { useState } from 'react';
import axios from 'axios';

const API = '/api';

const getAuthHeaders = () => {
  const token = localStorage.getItem('ebd_token');

  if (token) {
    try {
      const payload = JSON.parse(atob(token.split('.')[1]));
      const isExpired = payload.exp * 1000 < Date.now();

      if (isExpired) {
        localStorage.removeItem('ebd_token');
        localStorage.removeItem('ebd_user');
        localStorage.removeItem('last_data_update');
        window.location.reload();
        return {
          'Content-Type': 'application/json'
        };
      }
    } catch (error) {
      localStorage.removeItem('ebd_token');
      localStorage.removeItem('ebd_user');
      localStorage.removeItem('last_data_update');
      window.location.reload();
      return {
        'Content-Type': 'application/json'
      };
    }
  }

  return token ? {
    'Authorization': `Bearer ${token}`,
    'Content-Type': 'application/json'
  } : {
    'Content-Type': 'application/json'
  };
};

export const Turmas = ({ setCurrentView, currentUser, turmas, students, loadTurmas, planoInfo, onShowPlanos }) => {
  const [showForm, setShowForm] = useState(false);
  const [editingTurma, setEditingTurma] = useState(null);
  const [formData, setFormData] = useState({
    nome: '',
    descricao: ''
  });

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      if (editingTurma) {
        await axios.put(`${API}/turmas/${editingTurma.id}`, formData, {
          headers: getAuthHeaders()
        });
      } else {
        await axios.post(`${API}/turmas`, formData, {
          headers: getAuthHeaders()
        });
      }
      await loadTurmas(true);
      setShowForm(false);
      setEditingTurma(null);
      setFormData({ nome: '', descricao: '' });
      alert('Turma salva com sucesso!');
    } catch (error) {
      if (error.response?.status === 403 && error.response?.data?.detail?.includes('Limite')) {
        if (onShowPlanos && window.confirm(`${error.response.data.detail}\n\nDeseja ver os planos disponíveis?`)) {
          onShowPlanos();
        }
      } else if (error.response?.data?.detail) {
        alert(`Erro: ${error.response.data.detail}`);
      } else {
        alert('Erro ao salvar turma');
      }
    }
  };

  const handleEdit = (turma) => {
    setEditingTurma(turma);
    setFormData({
      nome: turma.nome,
      descricao: turma.descricao || ''
    });
    setShowForm(true);
  };

  const handleDelete = async (turmaId) => {
    if (window.confirm('Tem certeza que deseja remover esta turma?')) {
      try {
        await axios.delete(`${API}/turmas/${turmaId}`, {
          headers: getAuthHeaders()
        });
        await loadTurmas(true);
        alert('Turma removida com sucesso!');
      } catch (error) {
        if (error.response?.data?.detail) {
          alert(`Erro: ${error.response.data.detail}`);
        } else {
          alert('Erro ao remover turma');
        }
      }
    }
  };

  return (
    <div className="p-6 bg-gray-50 min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="mb-6">
          <button
            onClick={() => setCurrentView('dashboard')}
            className="mb-4 px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
          >
            ← Voltar ao Dashboard
          </button>
          {/* Indicador de limite do plano */}
          {planoInfo && planoInfo.turmas && planoInfo.plano !== 'free' && (
            <div className={`mb-3 flex items-center justify-between p-3 rounded-lg text-sm ${
              planoInfo.turmas.atual >= planoInfo.turmas.limite
                ? 'bg-red-50 border border-red-200 text-red-700'
                : planoInfo.turmas.atual >= planoInfo.turmas.limite * 0.8
                ? 'bg-yellow-50 border border-yellow-200 text-yellow-700'
                : 'bg-blue-50 border border-blue-200 text-blue-700'
            }`}>
              <span>
                <strong>{planoInfo.turmas.atual}/{planoInfo.turmas.limite}</strong> turmas ativas
                {' '}(Plano {planoInfo.plano_nome})
              </span>
              {planoInfo.turmas.atual >= planoInfo.turmas.limite && onShowPlanos && (
                <button
                  onClick={onShowPlanos}
                  className="ml-3 px-3 py-1 bg-emerald-600 text-white rounded-lg text-xs font-semibold hover:bg-emerald-700"
                >
                  Fazer Upgrade
                </button>
              )}
            </div>
          )}
          <div className="flex justify-between items-center">
            <h1 className="text-3xl font-bold text-gray-800">
              Gerenciar Turmas
            </h1>
            {(currentUser?.tipo === 'admin' || currentUser?.tipo === 'moderador') && (
              <button
                onClick={() => setShowForm(true)}
                className="px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-500"
              >
                Nova Turma
              </button>
            )}
          </div>
        </div>

        {/* Alerta de Demonstração - Apenas para visitante */}
        {currentUser?.tipo === 'visitante' && (
          <div className="mb-6 p-4 bg-yellow-100 border border-yellow-400 rounded-lg">
            <div className="flex items-center">
              <span className="text-yellow-800 text-lg font-semibold">
                ⚠️ MODO DEMONSTRAÇÃO: Apenas Visualização
              </span>
            </div>
          </div>
        )}

        {showForm && (
          <div className="bg-white rounded-lg shadow-lg p-6 mb-6">
            <h2 className="text-xl font-semibold text-gray-800 mb-4">
              {editingTurma ? 'Editar Turma' : 'Nova Turma'}
            </h2>
            <form onSubmit={handleSubmit} className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Nome</label>
                <input
                  type="text"
                  value={formData.nome}
                  onChange={(e) => setFormData({...formData, nome: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">Descrição</label>
                <input
                  type="text"
                  value={formData.descricao}
                  onChange={(e) => setFormData({...formData, descricao: e.target.value})}
                  className="w-full px-3 py-2 border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                />
              </div>
              <div className="md:col-span-2 flex space-x-4">
                <button
                  type="submit"
                  className="px-4 py-2 bg-green-500 text-white rounded-lg hover:bg-green-600 focus:outline-none focus:ring-2 focus:ring-green-500"
                >
                  {editingTurma ? 'Atualizar' : 'Criar'}
                </button>
                <button
                  type="button"
                  onClick={() => {
                    setShowForm(false);
                    setEditingTurma(null);
                    setFormData({ nome: '', descricao: '' });
                  }}
                  className="px-4 py-2 bg-gray-500 text-white rounded-lg hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-500"
                >
                  Cancelar
                </button>
              </div>
            </form>
          </div>
        )}

        <div className="bg-white rounded-lg shadow-lg p-6">
          <h2 className="text-xl font-semibold text-gray-800 mb-4">Lista de Turmas</h2>
          <div className="overflow-x-auto">
            <table className="w-full border-collapse border border-gray-200">
              <thead>
                <tr className="bg-gray-100">
                  <th className="border border-gray-300 px-4 py-2 text-left">Nome</th>
                  <th className="border border-gray-300 px-4 py-2 text-left">Descrição</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Alunos</th>
                  <th className="border border-gray-300 px-4 py-2 text-center">Ações</th>
                </tr>
              </thead>
              <tbody>
                {turmas.map((turma) => (
                  <tr key={turma.id} className="hover:bg-gray-50">
                    <td className="border border-gray-300 px-4 py-2 font-medium">{turma.nome}</td>
                    <td className="border border-gray-300 px-4 py-2">{turma.descricao || 'N/A'}</td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      {students.filter(s => s.turma_id === turma.id).length}
                    </td>
                    <td className="border border-gray-300 px-4 py-2 text-center">
                      {(currentUser?.tipo === 'visitante' || currentUser?.tipo === 'professor') ? (
                        <span className="text-gray-500 italic">Apenas visualização</span>
                      ) : (
                        <>
                          <button
                            onClick={() => handleEdit(turma)}
                            className="mr-2 px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600"
                          >
                            Editar
                          </button>
                          <button
                            onClick={() => handleDelete(turma.id)}
                            className="px-3 py-1 bg-red-500 text-white rounded hover:bg-red-600"
                          >
                            Remover
                          </button>
                        </>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  );
};
